import { ThunkDispatch } from 'redux-thunk';
import { centrifugeServices } from './CentrifugoService';
import {
  setCentrifugoChannels,
  setCentrifugoConnected,
  setCentrifugoInstance,
  setCentrifugoTokens,
} from './CentrifugoSlice';
import { CENTRIFUGE_URI } from '../../constants/env.constant';
import { Centrifuge } from 'centrifuge';

export const getCentrifugoConnectThunk =
  () => (dispatch: ThunkDispatch<any, any, any>) => {
    return new Promise((resolve, reject) =>
      centrifugeServices.getNotificationConnect().then(({ data }: any) => {
        const { tokens, channels } = data;
        dispatch(setCentrifugoChannels(channels));

        if (!CENTRIFUGE_URI) {
          reject('No set up Centrifugo URL');
          return;
        }

        const centrifugo = new Centrifuge(CENTRIFUGE_URI, {
          token: tokens.connection,
        });

        centrifugo.on('connected', ctx => {
          dispatch(setCentrifugoConnected(true));
          resolve(ctx);
        });
        centrifugo.on('error', ctx => {
          reject(ctx);
        });

        centrifugo.connect();

        dispatch(setCentrifugoTokens(tokens));
        dispatch(setCentrifugoInstance(centrifugo));
      }),
    );
  };
